// export const isSelfHosted = process.env.NEXT_PUBLIC_SELF_HOSTED === "true";
export const isSelfHosted = false;

export const appVersion = process.env.NEXT_PUBLIC_APP_VERSION;
